import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Button } from 'Components/ComponentLibrary/ExternalLibraries';

const styles = (theme) => ({
  root: {
    fontSize: theme.typography.h4.fontSize,
    fontWeight: theme.typography.fontWeightFacetBold,
    padding: theme.spacing(2),
    borderRadius: theme.radius.md,
  },
});

const TextButton = ({
  className,
  classes,
  children,
  color,
  weight,
  onClick,
  disabled,
  padding,
  size,
  variant,
}) => {
  return (
    <Button
      className={classNames(classes.root, className)}
      color={color}
      weight={weight}
      onClick={onClick}
      disabled={disabled}
      padding={padding}
      size={size}
      variant={variant}
    >
      {children}
    </Button>
  );
};

TextButton.defaultProps = {
  className: '',
  color: 'primary',
  weight: 'bold',
  onClick: () => {},
  disabled: false,
  padding: undefined,
  size: undefined,
  variant: 'text',
};

TextButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  weight: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  padding: PropTypes.string,
  size: PropTypes.string,
  variant: PropTypes.string,
};

export default withStyles(styles)(TextButton);
